import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getServiceNotes } from '../common/service-notes';

/**ToDo Documentazione */
@Component({
  selector: 'app-transfers',
  styleUrls: ['./transfers.component.scss'],
  templateUrl: './transfers.component.html'
})
export class TransfersComponent {
  @Input() public day: any;
  @Input() public showOptionlServices: any;
  @Input() public version: any;
  @Input() public noImageUrl: any;
  @Input() public defaultImage: any;
  @Input() public replaceShowDescriptionButtonWithNotes: boolean = false;
  @Input() public serviceIcons: any;
  state: any = sessionStorage.getItem('state');

  public getServiceIconPath(name: string): string | undefined {
    return this.serviceIcons ? this.serviceIcons[name] : undefined;
  }

  public getFilteredNotes(notes: any): any[] {
    return getServiceNotes(notes, this.state);
  }

  public language: string;

  constructor(public translateService: TranslateService) {
    console.log(this.version)
    this.language = translateService.currentLang;
  }

  handleImgError(ev: any){
    const source = ev.target as HTMLImageElement;
    const fallback = `assets/custom/${sessionStorage.getItem('version')}/images/logo_tour_operator.png`;
    source.src = this.noImageUrl || fallback;
  }

  public getSupplementsAndReductions(service: any): any[] {
    const source = service?.supplementsAndReductions
      || service?.items?.[0]?.supplementsAndReductions
      || service?.optionals?.[0]?.supplementsAndReductions
      || [];
    return Array.isArray(source) ? source : [];
  }

  public hasSupplementsAndReductions(service: any): boolean {
    return this.getSupplementsAndReductions(service).length > 0;
  }
}
